var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sign-info" },
    [
      _c("role-tab", { attrs: { ywtTab: true } }),
      _c(
        "div",
        { staticClass: "main-wrap" },
        [
          _c(
            "div",
            { staticClass: "left-wrap" },
            [
              _vm.$store.getters.currentAuthUser.userStemFrom !== -16 ||
              _vm.isInDingTalk
                ? _c("publish-sign", {
                    staticClass: "publish",
                    attrs: { fileText: "发起签署", tplText: "模板发起签署" }
                  })
                : _c("div", { staticClass: "dindin_code" }, [
                    _c("img", {
                      staticClass: "code_img",
                      attrs: {
                        src: require("../../static/images/dindin_code.png"),
                        alt: ""
                      }
                    })
                  ]),
              _c(
                "el-tabs",
                {
                  staticClass: "tabs-style",
                  attrs: { stretch: true },
                  model: {
                    value: _vm.tabsActive,
                    callback: function($$v) {
                      _vm.tabsActive = $$v
                    },
                    expression: "tabsActive"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "由我经办的", name: "contract" } },
                    [
                      _c("apply-menu-tree", {
                        ref: "menuTree",
                        staticClass: "menu-tree",
                        attrs: {
                          defaultExpandedKeys: ["changeUserInfo"],
                          currentMenuName: _vm.currentMenuName,
                          initCallback: _vm.initMenuTree,
                          menus: _vm.menus
                        },
                        on: {
                          "update:currentMenuName": function($event) {
                            _vm.currentMenuName = $event
                          },
                          "update:current-menu-name": function($event) {
                            _vm.currentMenuName = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "授权给我的", name: "overview" } },
                    [_c("contract-tab-left")],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("contarct-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabsActive == "overview",
                expression: "tabsActive == 'overview'"
              }
            ],
            staticClass: "right-wrap"
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.tabsActive == "contract",
                  expression: "tabsActive == 'contract'"
                }
              ],
              staticClass: "right-wrap"
            },
            [
              _c("route-name", {
                style: {
                  fontSize: "16px",
                  lineHeight: "36px",
                  backgroundColor: "#fff",
                  paddingLeft: "16px",
                  fontWeight: "600",
                  borderBottom: "solid 1px #E5E5E5"
                },
                attrs: { propsRouteName: _vm.computedCurrentMenuName }
              }),
              _c(
                "div",
                { attrs: { id: "nuxt-view" } },
                [
                  _c("nuxt-child", {
                    ref: "rightWrap",
                    attrs: { badge: _vm.badge },
                    on: {
                      "update:badge": function($event) {
                        _vm.badge = $event
                      },
                      batchLength: _vm.batchLength,
                      emitFn: _vm.emitFn
                    }
                  })
                ],
                1
              ),
              _vm.showDirBtn
                ? _c(
                    "el-button",
                    {
                      class:
                        _vm.$route.fullPath.indexOf("applyList?match=-1") > -1
                          ? "outbox"
                          : "inbox",
                      staticStyle: {
                        position: "absolute",
                        top: "108px",
                        "z-index": "1000"
                      },
                      attrs: { size: "small" },
                      on: { click: _vm.saveToDir }
                    },
                    [_vm._v("归档")]
                  )
                : _vm._e(),
              _vm.currentPathDirType === 2 && _vm.$route.query.directoryId
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          "z-index": "1000"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.dirMove()
                              }
                            }
                          },
                          [_vm._v("归档")]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.currentPathDirType === 1 &&
              _vm.$route.query.directoryId &&
              false
                ? [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          position: "absolute",
                          bottom: "15px",
                          left: "15px",
                          "z-index": "1000"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.dirMove()
                              }
                            }
                          },
                          [_vm._v("归档")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: {
                              click: function($event) {
                                return _vm.removeFromDir()
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.$route.query.signStatus == "4" && _vm.batch
                ? [
                    _c("div", {
                      staticStyle: {
                        position: "absolute",
                        top: "108px",
                        left: "290px",
                        "z-index": "1000"
                      }
                    })
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogFormVisible,
            title: _vm.currentDir.directoryId
              ? "重命名归档文件夹"
              : "添加归档文件夹",
            "close-on-click-modal": false,
            width: "460px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "10px 20px" } },
            [
              _c("el-col", { attrs: { span: 3 } }, [
                _c("span", { staticStyle: { "vertical-align": "middle" } }, [
                  _vm._v("名称：")
                ])
              ]),
              _c(
                "el-col",
                { attrs: { span: 21 } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入文件夹名称",
                      size: "small",
                      maxlength: 10
                    },
                    model: {
                      value: _vm.currentDir.name,
                      callback: function($$v) {
                        _vm.$set(_vm.currentDir, "name", $$v)
                      },
                      expression: "currentDir.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.createOrUpdateDir()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-height",
          attrs: {
            visible: _vm.showAllDirs,
            title: "选择归档文件夹",
            "close-on-click-modal": false,
            width: "460px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showAllDirs = $event
            }
          }
        },
        [
          _c(
            "ul",
            { staticClass: "move-to-dir" },
            [
              _vm.currentPathDirType === 1
                ? _vm._l(_vm.dirList, function(folder, index) {
                    return _c(
                      "li",
                      {
                        key: "folder-" + index,
                        class: { active: _vm.choosenFolder.index === index },
                        on: {
                          click: function($event) {
                            return _vm.chooseFolder(folder, index)
                          }
                        }
                      },
                      [
                        folder.nodeIcon
                          ? _c("span", { class: folder.nodeIcon })
                          : _vm._e(),
                        _vm._v(
                          "\n          " + _vm._s(folder.label) + "\n        "
                        )
                      ]
                    )
                  })
                : _vm._e(),
              _vm.currentPathDirType === 2
                ? _vm._l(_vm.receivedDirList, function(folder, index) {
                    return _c(
                      "li",
                      {
                        key: "folder-" + index,
                        class: { active: _vm.choosenFolder.index === index },
                        on: {
                          click: function($event) {
                            return _vm.chooseFolder(folder, index)
                          }
                        }
                      },
                      [
                        folder.nodeIcon
                          ? _c("span", { class: folder.nodeIcon })
                          : _vm._e(),
                        _vm._v(
                          "\n          " + _vm._s(folder.label) + "\n        "
                        )
                      ]
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.showAllDirs = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.saveApplySignToDir()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-height",
          attrs: {
            visible: _vm.moveDirVisible,
            title: "选择归档文件夹",
            "close-on-click-modal": false,
            width: "460px"
          },
          on: {
            "update:visible": function($event) {
              _vm.moveDirVisible = $event
            }
          }
        },
        [
          _c(
            "ul",
            { staticClass: "move-to-dir" },
            _vm._l(_vm.moveDirList, function(folder, index) {
              return _c(
                "li",
                {
                  key: "received-folder-" + index,
                  class: { active: _vm.choosenFolder.index === index },
                  on: {
                    click: function($event) {
                      return _vm.chooseFolder(folder, index)
                    }
                  }
                },
                [
                  folder.nodeIcon
                    ? _c("span", { class: folder.nodeIcon })
                    : _vm._e(),
                  _vm._v("\n        " + _vm._s(folder.label) + "\n      ")
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.moveDirVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.moveApplySignToDir()
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b70f527", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b70f527","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/corp/signInfo.vue
// module id = khc3
// module chunks = 24